"use client";

import * as S from "./styles.ts";
import Header from "./Header";
import { IButtonProps } from "@template/components/Button";
import Inputs from "@template/blocks/domain/DomainNamePricingTable/Inputs";
import Results from "@template/blocks/domain/DomainNamePricingTable/Results";

const DomainNamePricingTable = ({
  title,
  button,
}: {
  title?: string;
  button?: IButtonProps;
}) => {
  return (
    <S.Wrapper>
      <S.Container>
        <Header
          title={title}
          button={button}
        />
        <Inputs />
        <Results />
      </S.Container>
    </S.Wrapper>
  );
};

export default DomainNamePricingTable;
